import { ISubmitButtonLabels } from './Button.interface';

export const BUTTON_VARIANTS = [
  'secondary',
  'primary',
  'transparent',
  'obscure',
  'shade',
  'tints-default-medium-light',
];

const SUBMIT_BUTTON_SAVE = 'Save';
const SUBMIT_BUTTON_UPDATE = 'Update';

export const SUBMIT_BUTTON_LABELS = {
  save: SUBMIT_BUTTON_SAVE as ISubmitButtonLabels,
  update: SUBMIT_BUTTON_UPDATE as ISubmitButtonLabels,
  done: 'Done' as ISubmitButtonLabels,
  next: 'Next' as ISubmitButtonLabels,
  continue: 'Continue' as ISubmitButtonLabels,
  ok: 'OK' as ISubmitButtonLabels,
};
